import { render, staticRenderFns } from "./TablaAnalisisPorModulos.vue?vue&type=template&id=74ecf450&scoped=true"
import script from "./TablaAnalisisPorModulos.vue?vue&type=script&lang=js"
export * from "./TablaAnalisisPorModulos.vue?vue&type=script&lang=js"
import style0 from "./TablaAnalisisPorModulos.vue?vue&type=style&index=0&id=74ecf450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecf450",
  null
  
)

export default component.exports